import { t } from '@/ui/i18n/i18n';

export const separateTodoValues = () => [
  {
    key: false,
    value: t('schedules.only-one'),
    status: 'bg-blue',
  },
  {
    key: true,
    value: t('schedules.all'),
    status: 'bg-blue',
  },
];
